/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/string/Format.ts
 * @create:      2025-06-26 11:10:46.067
 * @modify:      2025-07-11 21:19:12.825
 * @version:     6.0.0
 * @times:       6
 * @lines:       63
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Formats a string by replacing placeholders with corresponding arguments.
 *
 * Replaces each occurrence of `{0}`, `{1}`, `{2}`, etc., in the `format` string
 * with the respective value from `args`.
 *
 * @param format - The string containing placeholders in the form `{n}` where `n` is a zero-based index.
 * @param args - The values to replace the placeholders with. Each argument can be a string or number.
 * @returns The formatted string with all placeholders replaced by their corresponding arguments.
 *
 * @example
 * ```typescript
 * Format("Hello, {0}!", "World"); // Returns "Hello, World!"
 * Format("{0} + {0} = {1}", 2, 4); // Returns "2 + 2 = 4"
 * ```
 * 
 * @since 4.0.0
 * @version 2021-12-14
 */
export function Format(format: string, ...args: (string | number)[]) {
    let str = format;
    const len = args.length;

    // For each {0} {1} {n...} replace with the argument in that position.
    for (let i = 0; i < len; i++) {
        str = str.replace(RegExp("\\{" + i + "\\}", "g"), args[i].toString());
    }

    return str;
}
